import { render, staticRenderFns } from "./UserTabRights.vue?vue&type=template&id=769018fe&scoped=true"
import script from "./UserTabRights.vue?vue&type=script&lang=ts"
export * from "./UserTabRights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769018fe",
  null
  
)

export default component.exports